import { combineReducers } from "redux";
import theme from "./themeStore";

// Parametrage

import {
  addFamille,
  updateFamille,
  deleteFamille,
  getAllFamilles
} from "./Parametrage/Famille";

import {
  addArticle,
  deleteArticle,
  updateArticle,
  getAllArticles
} from "./Parametrage/Article";

import {
  addNumerisation,
  updateNumerisation,
  deleteNumerisation,
  getAllNumerisations
} from "./Parametrage/Numerisation";

import {
  addClient,
  updateClient,
  deleteClient,
  getAllClients
} from "./Parametrage/Client";

import {
  addSousClient,
  updateSousClient,
  deleteSousClient,
  getAllSousClients
} from "./Parametrage/SousClient";

import {
  addFournisseur,
  updateFournisseur,
  deleteFournisseur,
  getAllFournisseurs
} from "./Parametrage/Fournisseur";

import { addPompe, updatePompe, deletePompe } from "./Parametrage/Pompe";

import {
  addReservoir,
  updateReservoir,
  deleteReservoir,
  getAllReservoirs,
  getReservoirById
} from "./Parametrage/Reservoir";

import {
  addVehicule,
  updateVehicule,
  deleteVehicule,
  getAllVehicules
} from "./Parametrage/Vehicule";

import {
  addChauffeur,
  updateChauffeur,
  deleteChauffeur,
  getAllChauffeurs
} from "./Parametrage/Chauffeur";

// Parametrage

// Achat

import {
  addBonCommande,
  getBonCommande,
  updateBonCommande,
  deleteBonCommande,
  getAllBonCommandes,
  addBCArticle,
  getBCArticle,
  updateBCArticle,
  deleteBCArticle
} from "./Achat/BonCommande";

import {
  addBonReception,
  getBonReception,
  updateBonReception,
  deleteBonReception,
  getAllBonReceptions,
  addRCArticle,
  getRCArticle,
  updateRCArticle,
  deleteRCArticle
} from "./Achat/BonReception";

import {
  addFacture,
  getFacture,
  updateFacture,
  deleteFacture,
  getAllFactures,
  addArticleFact,
  getArticleFact,
  updateArticleFact,
  deleteArticleFact
} from "./Achat/Facture";

import {
  addFactureAvoir,
  getFactureAvoir,
  updateFactureAvoir,
  deleteFactureAvoir,
  getAllFactureAvoirs,
  addArticleFactAvoir,
  updateArticleFactAvoir,
  deleteArticleFactAvoir
} from "./Achat/FactureAvoir";

// Achat

// Vente

import {
  addDevis,
  getDevis,
  updateDevis,
  deleteDevis,
  getAllDevis,
  addDVArticle,
  updateDVArticle,
  deleteDVArticle
} from "./Vente/Devis";

import {
  addBonG,
  getBonG,
  updateBonG,
  deleteBonG,
  getAllBonG,
  addBNArticle,
  updateBNArticle,
  deleteBNArticle
} from "./Vente/BonG";

import {
  addBonL,
  getBonL,
  updateBonL,
  deleteBonL,
  getAllBonL,
  addBLArticle,
  updateBLArticle,
  deleteBLArticle
} from "./Vente/BonL";

// Vente

export default combineReducers({
  theme,

  // Parametrage

  addNumerisation,
  updateNumerisation,
  deleteNumerisation,
  getAllNumerisations,
  addFamille,
  updateFamille,
  deleteFamille,
  getAllFamilles,
  getAllArticles,
  deleteArticle,
  updateArticle,
  addArticle,
  addFournisseur,
  updateFournisseur,
  deleteFournisseur,
  getAllFournisseurs,
  addClient,
  updateClient,
  deleteClient,
  getAllClients,
  addSousClient,
  updateSousClient,
  deleteSousClient,
  getAllSousClients,
  addVehicule,
  updateVehicule,
  deleteVehicule,
  getAllVehicules,
  addChauffeur,
  updateChauffeur,
  deleteChauffeur,
  getAllChauffeurs,
  addReservoir,
  updateReservoir,
  deleteReservoir,
  getAllReservoirs,
  getReservoirById,
  addPompe,
  updatePompe,
  deletePompe,

  // Parametrage

  // Achat

  addBonCommande,
  getBonCommande,
  updateBonCommande,
  deleteBonCommande,
  getAllBonCommandes,
  addBCArticle,
  getRCArticle,
  updateBCArticle,
  deleteBCArticle,

  addBonReception,
  getBonReception,
  updateBonReception,
  deleteBonReception,
  getAllBonReceptions,
  addRCArticle,
  getBCArticle,
  updateRCArticle,
  deleteRCArticle,

  addFacture,
  getFacture,
  updateFacture,
  deleteFacture,
  getAllFactures,
  addArticleFact,
  getArticleFact,
  updateArticleFact,
  deleteArticleFact,

  addFactureAvoir,
  getFactureAvoir,
  updateFactureAvoir,
  deleteFactureAvoir,
  getAllFactureAvoirs,
  addArticleFactAvoir,
  updateArticleFactAvoir,
  deleteArticleFactAvoir,

  // Achat

  // Vente

  addDevis,
  getDevis,
  updateDevis,
  deleteDevis,
  getAllDevis,
  addDVArticle,
  updateDVArticle,
  deleteDVArticle,

  addBonG,
  getBonG,
  updateBonG,
  deleteBonG,
  getAllBonG,
  addBNArticle,
  updateBNArticle,
  deleteBNArticle,

  addBonL,
  getBonL,
  updateBonL,
  deleteBonL,
  getAllBonL,
  addBLArticle,
  updateBLArticle,
  deleteBLArticle

  // Vente
});
